const countriesData = [
  // {
  //   name: "United States",
  //   code: "US",
  //   states: [
  //     { name: "Alabama", code: "AL" },
  //     { name: "Alaska", code: "AK" },
  //     { name: "Arizona", code: "AZ" },
  //     { name: "Arkansas", code: "AR" },
  //     { name: "California", code: "CA" },
  //     { name: "Colorado", code: "CO" },
  //     { name: "Connecticut", code: "CT" },
  //     { name: "Delaware", code: "DE" },
  //     { name: "Florida", code: "FL" },
  //     { name: "Georgia", code: "GA" },
  //     { name: "Hawaii", code: "HI" },
  //     { name: "Idaho", code: "ID" },
  //     { name: "Illinois", code: "IL" },
  //     { name: "Indiana", code: "IN" },
  //     { name: "Iowa", code: "IA" },
  //     { name: "Kansas", code: "KS" },
  //     { name: "Kentucky", code: "KY" },
  //     { name: "Louisiana", code: "LA" },
  //     { name: "Maine", code: "ME" },
  //     { name: "Maryland", code: "MD" },
  //   ],
  // },
  // {
  //   name: "Canada",
  //   code: "CA",
  //   states: [
  //     { name: "Alberta", code: "AB" },
  //     { name: "British Columbia", code: "BC" },
  //     { name: "Manitoba", code: "MB" },
  //     { name: "New Brunswick", code: "NB" },
  //     { name: "Newfoundland and Labrador", code: "NL" },
  //     { name: "Nova Scotia", code: "NS" },
  //     { name: "Ontario", code: "ON" },
  //     { name: "Prince Edward Island", code: "PE" },
  //     { name: "Quebec", code: "QC" },
  //     { name: "Saskatchewan", code: "SK" },
  //   ],
  // },
  {
    name: "India",
    code: "IN",
    states: [
      { name: "Andhra Pradesh", code: "AP" },
      { name: "Arunachal Pradesh", code: "AR" },
      { name: "Assam", code: "AS" },
      { name: "Bihar", code: "BR" },
      { name: "Chhattisgarh", code: "CG" },
      { name: "Goa", code: "GA" },
      { name: "Gujarat", code: "GJ" },
      { name: "Haryana", code: "HR" },
      { name: "Himachal Pradesh", code: "HP" },
      { name: "Jharkhand", code: "JH" },
      { name: "Karnataka", code: "KA" },
      { name: "Kerala", code: "KL" },
      { name: "Madhya Pradesh", code: "MP" },
      { name: "Maharashtra", code: "MH" },
      { name: "Manipur", code: "MN" },
      { name: "Meghalaya", code: "ML" },
      { name: "Mizoram", code: "MZ" },
      { name: "Nagaland", code: "NL" },
      { name: "Odisha", code: "OR" },
      { name: "Punjab", code: "PB" },
      { name: "Rajasthan", code: "RJ" },
        { name: "Sikkim", code: "SK" },
        { name: "Tamil Nadu", code: "TN" },
        { name: "Telangana", code: "TG" },
        { name: "Tripura", code: "TR" },
        { name: "Uttar Pradesh", code: "UP" },
        { name: "Uttarakhand", code: "UK" },
        { name: "West Bengal", code: "WB" }
    ],
  },
  // {
  //   name: "Australia",
  //   code: "AU",
  //   states: [
  //     { name: "New South Wales", code: "NSW" },
  //     { name: "Queensland", code: "QLD" },
  //     { name: "South Australia", code: "SA" },
  //     { name: "Tasmania", code: "TAS" },
  //     { name: "Victoria", code: "VIC" },
  //     { name: "Western Australia", code: "WA" },
  //   ],
  // },
  // {
  //   name: "Germany",
  //   code: "DE",
  //   states: [
  //     { name: "Baden-Württemberg", code: "BW" },
  //     { name: "Bavaria", code: "BY" },
  //     { name: "Berlin", code: "BE" },
  //     { name: "Brandenburg", code: "BB" },
  //     { name: "Bremen", code: "HB" },
  //     { name: "Hamburg", code: "HH" },
  //     { name: "Hesse", code: "HE" },
  //     { name: "Lower Saxony", code: "NI" },
  //     { name: "Mecklenburg-Vorpommern", code: "MV" },
  //     { name: "North Rhine-Westphalia", code: "NW" },
  //     { name: "Rhineland-Palatinate", code: "RP" },
  //     { name: "Saarland", code: "SL" },
  //     { name: "Saxony", code: "SN" },
  //     { name: "Saxony-Anhalt", code: "ST" },
  //     { name: "Schleswig-Holstein", code: "SH" },
  //     { name: "Thuringia", code: "TH" },
  //   ],
  // },
  {
    name: "United Kingdom",
    code: "UK",
    states: [
      { name: "England", code: "ENG" },
      { name: "Scotland", code: "SCT" },
      { name: "Wales", code: "WLS" },
      { name: "Northern Ireland", code: "NIR" },
    ],
  },
];

export default countriesData;
